module.exports = __webpack_public_path__ + "img/yinhao.51ab2e19.png";